import createLucideIcon from '../createLucideIcon';

const Delete = createLucideIcon('Delete', [
  [
    'path',
    { d: 'M20 5H9l-7 7 7 7h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Z', key: '1oy587' },
  ],
  ['line', { x1: '18', x2: '12', y1: '9', y2: '15', key: '1olkx5' }],
  ['line', { x1: '12', x2: '18', y1: '9', y2: '15', key: '1n50pc' }],
]);

export default Delete;
